import React, { useState, useEffect } from "react";

export default function News() {
  const [newsData, setNewsData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = "News";
  }, []);
  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch(
          "https://lifetimedesign.in/LtcJsonAPI.asmx/NewsList",
        );
        const data = await res.json();

        const result = data?.d || data;

        if (result.success) {
          setNewsData(result.data || []);
        } else {
          setNewsData([]);
        }
      } catch (err) {
        setError("Failed to load news");
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []); // ✅ FIXED
  const breadcrumbItems = [
    {
      label: (
        <>
          <i className="bi bi-house"></i> Home
        </>
      ),
      link: "/",
    },
    {
      label: "Latest Updates",
      link: "/news",
    },
  ];
  if (loading) return <p className="center">Loading...</p>;
  if (error) return <p className="center error">{error}</p>;

  return (
    <div className="news-container">
      <div className="container-fluid">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbItems.map((item, i) => (
              <li
                key={i}
                className={`breadcrumb-item ${i === breadcrumbItems.length - 1 ? "active" : ""}`}
              >
                {i === breadcrumbItems.length - 1 ? (
                  item.label
                ) : (
                  <a href={item.link}>{item.label}</a>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      <h2 className="news-title">Latest Updates</h2>

      {newsData.length === 0 ? (
        <p className="center">No updates available</p>
      ) : (
        <div className="news-list">
          {newsData.map((item, index) => (
            <div className="news-item" key={item.id || index}>
              <div className="news-row">
                <h4 className="news-name">
                  {item.name || `Update ${index + 1}`}
                </h4>

                <p className="news-desc">
                  {item.description
                    ? item.description.substring(0, 120)
                    : "No description available"}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
